module.exports = __webpack_public_path__ + "img/4.98290968.jpg";